
import getVideoId from "get-video-id";
export default {
  data() {
    return {
      pageData: null,
      videoID: null,
      options: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "time",
          label: "Trajanje",
          type: "text",
        },
        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
        {
          name: "thumbnail",
          label: "Thumbnail",
          type: "image",
          size: "300x168",
        },
        {
          name: "link",
          label: "Youtube link",
          type: "link",
        },
      ],
    };
  },
  watch: {
    selectedCategory() {
      this.changeCategory();
    },
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.pageData = this.$parent.$parent.pageData;
    },
    closeVideoModal(val) {
      this.videoID = null;
      document.body.classList.remove("modal-open");
    },
    openVideoModal(val) {
      this.videoID = getVideoId(val);
      document.body.classList.add("modal-open");
    },
  },
};
